export default class {

    // @ngInject
    constructor($location, authService, signupDataStore, responseHandler, $window) {

        // $window.ga('send', 'pageview', $location.url());
        $window.gtag('config', 'G-Z5WQRDSH6E');

        if (!signupDataStore.account) {
            $location.path('/');
        }
        this.authService = authService;
        this.responseHandler = responseHandler;
        this.isUnverifiedVariant = $location.path() === '/login/unverified';
        this.account = signupDataStore.account;
        this.resent = false;

    }

    resend() {
        let data = {email: this.account.email};
        this.responseHandler(
            this.authService.resendEmailConfirmation(data),
            'resending the email'
        ).then(() => this.resent = true);
    }

}



// WEBPACK FOOTER //
// ./signup-basic/confirmation/confirmation-ctrl.js